<template>
    <div>
        <div class="exp-box">
            <span class="normal-span" tkey="店鋪到期時間">{{i18n.tkey("lang_shop_exp")}}</span>：<shopExpirationSpan />
            &nbsp;&nbsp;
            <el-text type="danger" tag="ins" tkey="續費" @click="clickRenewBtn">{{i18n.tkey("lang_renew")}}</el-text>
        </div>

<!--        <div>-->
<!--            <el-button style="width: 100%" tkey="我的賬單">{{i18n.tkey("lang_bill")}}</el-button>-->
<!--        </div>-->
    </div>
</template>

<script setup>
    import shopExpirationSpan from "@/components/shopopee/shop/shopExpirationSpan"
    import {inject, getCurrentInstance} from "vue";

    const { proxy } = getCurrentInstance()
    const i18n = inject("i18n")

    function clickRenewBtn(){
        location.href = `${proxy.$ShopopeeUrl}apply_renew`
    }

</script>

<style scoped>
    .exp-box {
        text-align: left;
        line-height: 2.5;
    }

    .normal-span {
        font-size: 14px;
        color: #303133;
    }
</style>